import React from "react";
import Subscriber from "../../subscriber.class";
import Storage from "../../services/storage.service";
import Settings from "../../services/settings";
export default class SmartBanner extends Subscriber {
  state = {
    closed: false,
    ios: null,
    android: null,
  };

  componentDidMount() {
    this.subscriptions.push(
      Storage.get_obsrv("businessConfig").subscribe((business) => {
        if (business && business["smart_banner_apps_rating"]) {
          let arr = business["smart_banner_apps_rating"][0];
          if (arr && arr["Android"] && arr["iOS"]) {
            this.setState({
              ios: arr["iOS"],
              android: arr["Android"],
            });
          }
        }
      })
    );
  }

  render() {
    let stars = "";

    if (this.state.ios && this.state.android) {
      let ios_count = (this.state.ios.count / 1000).toFixed(2);
      let android_count = (this.state.android.count / 1000).toFixed(2);
      let ios_width = this.state.ios.rating * 20;
      let android_width = this.state.android.rating * 20;

      stars = (
        <>
          <div className="app_stars_wrapper android">
            <div className="app_stars">
              <div
                className="app_stars_progress"
                style={{ width: android_width + "%" }}
              />
            </div>
          </div>
          <div className="app_views android">{android_count}k</div>
          <div className="app_stars_wrapper ios">
            <div className="app_stars">
              <div
                className="app_stars_progress"
                style={{ width: ios_width + "%" }}
              />
            </div>
          </div>
          <div className="app_views ios"> {ios_count}k</div>
        </>
      );
    }
    if (!this.state.closed) {
      return (
        <>
        {/*<div className="smart_banner_space" />*/}
        <div className="smart_banner">
          <div className="smart_banner_inner">
            <div
              className="app_close"
              onClick={() => {
                this.setState({ closed: true });
              }}
            />

            <div className="app_logo" />
            <div className="app_name">Virgin Mobile UAE</div>
            {stars}
            <div className="app_open ios">
              <a href={`${Settings.deeplink_domain}/app`}>open</a>
            </div>
            <div className="app_open android">
              <a href={`${Settings.deeplink_domain}/app`}>open</a>
            </div>
          </div>
        </div>
        </>
      );
    }
    return "";
  }
}
